import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'

export let startLti13Logs = userId => {
  const root = createRoot(document.getElementById('lti13LogsApp'))
  root.render(<App userId={userId} />)
}
